<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3 id="title1">{{ pageOperatorTitle }}</h3>
      <h3 id="title2">{{ 'PARKING LICENSE AGREEMENT ' + (pageCustomerType ? `(${pageCustomerType})` : '') }}</h3>
      <hr>

      <p
        v-show="pageShowData">
        PLEASE READ THIS
        <br>
        1. Click here to <a href="#" v-on:click.prevent="printPDF">print this Parking License Agreement</a>.
        <br>
        <span v-html="tnc"></span>
      </p>

      <div id="print_area">
      
        <AppForm
          v-show="pageShowData"
          ref="pageForm" 
          v-bind:formParameter="PARAM"
          v-bind:permission="permission" >

          <div
            slot="jt-form-slot-sectionProductSubscription">
            <PagePLViewLease
              ref="pageTableLease" />
          </div>
          
        </AppForm>

      </div>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import PagePLViewLease from "@/components/Page/ParkingLicense/PagePLViewLease";

import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

const PARAM = [
  {
    form_section: 'PARKING LICENSE INFORMATION',
  },
  {
    key: 'licenseType',
    text: 'License Type',
  },
  {
    key: 'licenseNumText',
    text: 'Parking License No.',
  },
  {
    key: 'licenseCarPark',
    text: 'Parking License Car Park',
  },
  {
    key: 'licenseStatus',
    text: 'Parking License Status',
  },
  {
    form_section: 'PERSONAL DETAILS',
  },
  {
    key: 'licensePersonalName',
    text: 'Personal Full Name',
  },
  {
    key: 'licensePersonalNationalID',
    text: 'NRIC / Passport No',
  },
  {
    key: 'licensePersonalEmail',
    text: 'Email',
  },
  {
    key: 'licensePersonalPhoneMobile',
    text: 'Phone No. (Mobile) ',
  },
  {
    key: 'licensePersonalPhoneResidential',
    text: 'Phone No. (Residential)',
  },
  {
    key: 'licensePersonalCorrespondenceAddress',
    text: 'Correspondence Address',
  },
  {
    key: 'licensePersonalPermanentAddress',
    text: 'Permanent Address',
  },
  {
    form_section: 'EMERGENCY CONTACT DETAILS',
  },
  {
    key: 'licensePersonalEmergencyName',
    text: 'Emergency Contact Name',
  },
  {
    key: 'licensePersonalEmergencyRelationship',
    text: 'Relationship',
  },
  {
    key: 'licensePersonalEmergencyPhoneResidential',
    text: 'Emergency Phone No. (Residential)',
  },
  {
    key: 'licensePersonalEmergencyPhoneOffice',
    text: 'Emergency Phone No. (Office)',
  },
  {
    key: 'licensePersonalEmergencyPhoneMobile',
    text: 'Emergency Phone No. (Mobile)',
  },
  {
    form_section: 'COMPANY DETAILS',
  },
  {
    key: 'licenseCompanyName',
    text: 'Company Name',
  },
  {
    key: 'licenseCompanyNationalID',
    text: 'Company Registration No.',
  },
  {
    key: 'licenseCompanyAddress',
    text: 'Company Address',
  },
  {
    key: 'licenseCompanyTelephone',
    text: 'Company Telephone No.',
  },
  {
    key: 'licenseCompanyFax',
    text: 'Company Fax No.',
  },
  {
    key: 'licenseCompanyTenant',
    text: 'Car Park Tenant',
  },
  {
    form_section: 'CONTACT PERSON DETAILS',
  },
  {
    key: 'licenseCompanyPICName',
    text: 'Company PIC Name',
  },
  {
    key: 'licenseCompanyPICMobile',
    text: 'Company Phone (Mobile)',
  },
  {
    key: 'licenseCompanyPICEmail',
    text: 'Company PIC Email',
  },
  {
    form_section: 'PARKING PRODUCT SUBSCRIPTION DETAILS',
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    form_section: 'BILLING & CORRESPONDENCE INSTRUCTIONS',
  },
  {
    key: 'licenseAgreeEbill',
    text: 'I agree that all my bills will be sent to my email address as specified above (E-Billing)',
    form_html: function(formInputParameter, formData) {
      return `<div class="row">
      <label class="control-label text-left text-md-right col-md-3">${formInputParameter.text} :</label>
      <div class="col-md-9"><p class="form-control-static" id="input__bill1">Yes</p></div>
      </div>`;
    }
  },
  {
    key: 'licenseAgreeEmail',
    text: 'I authorise that all correspondences will be sent to my email address as specified above',
    form_html: function(formInputParameter, formData) {
      return `<div class="row">
      <label class="control-label text-left text-md-right col-md-3">${formInputParameter.text} :</label>
      <div class="col-md-9"><p class="form-control-static" id="input__bill2">Yes</p></div>
      </div>`;
    }
  },
  {
    form_section: 'DECLARATION',
  },
  {
    key: 'licenseDeclaration',
    form_html: function(formInputParameter, formData) {
      return `<div id="pl-declaration">I, ${formData['licenseDeclarationPerson']}, hereby declare that I have read the Terms and Conditions for this Parking License Agreement (PL No.: ${formData['licenseDeclarationAccount']}) and that the information detailed in this agreement is accurate to the best of my knowledge, and hereby subscribe to the service as stated in this parking license application.</div>`;
    }
  },
];

PARAM.forEach(k => {
  k['form_html'] = k['form_html'] || function(formInputParameter, formData) {
    return `<div class="row">
      <label class="control-label text-left text-md-right col-md-3">${formInputParameter.text} :</label>
      <div class="col-md-9"><p class="form-control-static">${formData[formInputParameter.key] || ' '}</p></div>
      </div>`;
      // the space is needed to pass DOM empty check
  }
});
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLView",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    PagePLViewLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageOperatorTitle: '',
      pageCustomerType: '',

      pageTitle: null,
      pageShowData: false,

      pageTenant: null,
      pageZone: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      licenseCache: null,
      licenseLease: null,
      licenseNo: '',

      tnc: '2. Click here to read the <a href="/plTnCview" target="_blank">Terms and Conditions</a> and <a href="/plPPview" target="_blank">Privacy Policy</a>.'
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/parkinglicense');
    });

    this.loadLicense();
  },
  methods: {
    hideFormFromKey(key) {
      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'applicationTotalAccessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },

    loadLicense() {
      let licenseID = this.$route.query.licenseID;
      if(licenseID) {
        this.$refs['pageFeedback'].setFeedbackLoading('Loading license data...');
        this.$http
          .get(
            helper.SERVER_URL + '/api2/license/' + licenseID,
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = response.data[0];
            if(tempData) {
              this.licenseCache = tempData;
              this.loadPasscard();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading license data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
          })
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Invalid Request');
      }
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/passcard/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + this.licenseCache['customerID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.licenseCache['_customer'] = tempData;
            if(tempData['address1']) {
              this.loadCity();
            } else if(tempData['contact1']) {
              this.loadApplicationCustomerContact();
            } else {
              this.loadTenant();
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    formAddress(key, data) {
      let addressParam = ['Address1', 'Address2', 'Address3', 'AddressPostalCode', 'AddressCityID', 'AddressStateID', 'AddressCountryID'];
      let address = '';
      addressParam.forEach(k => {
        if(data[key + k]) {
          if(k === 'AddressCityID') {
            let city = this.pageCity.find(j => helper.compareID(data[key + k], j.id));
            if(city) {
              data[key + 'AddressStateID'] = city['stateID'];
              address += (address ? ', ' : '') + city['name'];
              return;
            }
          } else if(k === 'AddressStateID') {
            let state = this.pageState.find(j => helper.compareID(data[key + k], j.id));
            if(state) {
              data[key + 'AddressCountryID'] = state['countryID'];
              address += (address ? ', ' : '') + state['name'];
              return;
            }
          } else if(k === 'AddressCountryID') {
            let country = this.pageCountry.find(j => helper.compareID(data[key + k], j.id));
            if(country) {
              address += (address ? ', ' : '') + country['name'];
              return;
            }
          }
          address += (address ? ', ' : '') + data[key + k];
        }
      });
      return address;
    },
    loadCity() {
      let feedbackItem = 'customer address city'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/city/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCity = response.data;
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadState() {
      let feedbackItem = 'customer address state'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/state/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageState = response.data;
          this.loadCountry();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCountry() {
      let feedbackItem = 'customer address country'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/country/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCountry = response.data;
          this.loadApplicationCustomerAddress();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadApplicationCustomerAddress() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer address data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + this.licenseCache['_customer']['address1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = helper.parseAddress(response);
          if(tempData) {
            this.licenseCache['_customer'] = Object.assign(tempData, this.licenseCache['_customer']);
            if(tempData['contact1']) {
              this.loadApplicationCustomerContact();
            } else {
              this.loadTenant();
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer address data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer address data'));
        })
    },
    loadApplicationCustomerContact() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer contact data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/contact/' + this.licenseCache['_customer']['contact1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = helper.parseContact(response);
          if(tempData) {
            this.licenseCache['_customer'] = Object.assign(tempData, this.licenseCache['_customer']);
            this.loadTenant();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer contact data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer contact data'));
        })
    },
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTenant = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.licenseCache['_carpark'] = tempData;
            this.tnc = `2. Click here to read the <a href="/plTnCview?operatorID=${tempData.operatorID}" target="_blank">Terms and Conditions</a> and <a href="/plPPview?operatorID=${tempData.operatorID}" target="_blank">Privacy Policy</a>.`
            this.loadCarparkFinance();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadCarparkFinance() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park info data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/finance',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.pageOperatorTitle = tempData.name;
            this.loadZone();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park info data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },
    loadLease() {
      let feedbackItem = 'lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // helper.SERVER_URL + '/api2/license/' + this.licenseCache['id'] + '/lease/?current=1',
          // helper.SERVER_URL + '/api2/license/' + this.licenseCache['id'] + '/lease/',
          // helper.SERVER_URL + '/api2/lease/?licenseID=' + this.licenseCache['id'],
          // helper.SERVER_URL + '/api2/carpark/' + this.licenseCache.carparkID + '/lease/',
          helper.SERVER_URL + '/api2/license/' + this.licenseCache.id + '/lease/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          // let tempData = response.data.filter(k => helper.compareID(k.licenseID, this.licenseCache.id) )
          // let tempData = response.data.filter(k => k.status === 'Active' || k.status === 'Stop Bill' || k.status === 'Pending Termination');
          if(tempData) {
            this.licenseCache['lease'] = tempData;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.pageSeason && this.pageParker) {
        if(this.pageSeason.length === 0) {
          this.$refs['pageFeedback'].setFeedbackError('No product available');
          return;
        }

        if(this.pageParker.length === 0) {
          this.$refs['pageFeedback'].setFeedbackError('No parker available');
          return;
        }

        // populate form + lease after loading both season and parker
        // or loading season/subscriber will change the select -> erase existing lease data
        if(this.licenseCache) {
          this.loadLicenseComplete();
          let temp = this.licenseCache;
          this.licenseCache = null;
          this.$refs['pageForm'].setForm(false, temp);
          this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData.lease);
          this.pageShowData = true;
          this.calculateParkingFees();
        }

        this.hideFormFromKey(null);
      }
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/season',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageFees[seasonID] = null;

      this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackLoading('Loading product fees data...');

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
            // if(this.pageFees[seasonID] = response.data[0]) {
            //   this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackMessage();
            //   this.calculateParkingFees();
            // } else {
            //   this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('No active product fees data available.');
            // }
          } else {
            this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('No product fees data available.');
          }
        })
        .catch(error => {
          this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product fees data'));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      this.$refs['pageFeedback'].setFeedbackLoading('Loading parker data...');

      let customerID = this.licenseCache['customerID'];
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'parker data'));
        })
    },

    loadLicenseComplete() {
      this.$refs['pageFeedback'].setFeedbackError();

      this.licenseCache['licenseCarPark'] = this.licenseCache['_carpark'].name;
      this.licenseCache['licenseStatus'] = '' + this.licenseCache['status'];
      this.licenseCache['licenseDateUpdate'] = '';
      this.licenseCache['licenseNumText'] = this.licenseNo = helper.plFormPLNum(this.licenseCache['licenseOperatorNum'], this.licenseCache['carparkID']);

      let customer = this.licenseCache['_customer'];
      this.licenseCache['licenseCompanyTelephone'] = customer['companyTelephone'];
      this.licenseCache['licenseCompanyFax'] = customer['companyFax'];
      this.licenseCache['licenseCompanyPICName'] = customer['companyPICname'];
      this.licenseCache['licenseCompanyPICMobile'] = customer['companyPICphone'];
      this.licenseCache['licenseCompanyPICEmail'] = customer['companyPICemail'];
      this.licenseCache['licenseCompanyAddress'] = this.formAddress('company', customer);

      if(customer.isCompany) {
        this.licenseCache['licenseCompanyName'] = customer['name'];
        this.licenseCache['licenseCompanyNationalID'] = customer['nationalID'];
        this.pageCustomerType = this.licenseCache['licenseType'] = 'Company';

        let shouldSplice = false;
        let spliceList = [];
        this.PARAM.forEach((k, j) => {
          if(k.form_section === 'PERSONAL DETAILS') {
            shouldSplice = true;
          } else if(k.form_section === 'COMPANY DETAILS') {
            shouldSplice = false;
            return true;
          }

          if(shouldSplice) {
            spliceList.push(j);
          }
        });
        if(spliceList.length > 0) {
          this.PARAM.splice(spliceList[0], spliceList.length);
        }

        this.licenseCache['licenseDeclarationPerson'] = this.licenseCache['licenseCompanyPICName'] + ' of ' + this.licenseCache['licenseCompanyName'];
      } else {
        this.licenseCache['licensePersonalName'] = customer['name'];
        this.licenseCache['licensePersonalNationalID'] = customer['nationalID'];
        this.licenseCache['licensePersonalEmail'] = customer['personalEmail'];
        this.licenseCache['licensePersonalPhoneMobile'] = customer['personalPhoneMobile'];
        this.licenseCache['licensePersonalPhoneResidential'] = customer['personalPhoneResidential'];
        this.licenseCache['licensePersonalCorrespondenceAddress'] = this.formAddress('personalCorrespondence', customer);
        this.licenseCache['licensePersonalPermanentAddress'] = this.formAddress('personalPermanent', customer);

        this.licenseCache['licensePersonalEmergencyName'] = customer['emergencyName'];
        this.licenseCache['licensePersonalEmergencyRelationship'] = customer['emergencyRelationship'];
        this.licenseCache['licensePersonalEmergencyPhoneResidential'] = customer['emegencyPhoneResidential'];
        this.licenseCache['licensePersonalEmergencyPhoneOffice'] = customer['emegencyPhoneOffice'];
        this.licenseCache['licensePersonalEmergencyPhoneMobile'] = customer['emegencyPhoneMobile'];

        this.licenseCache['licenseCompanyName'] = customer['companyName'];
        this.licenseCache['licenseCompanyNationalID'] = customer['companyNationalID'];
        this.pageCustomerType = this.licenseCache['licenseType'] = 'Personal';

        this.licenseCache['licenseDeclarationPerson'] = this.licenseCache['licensePersonalName'] + ' (' + this.licenseCache['licensePersonalNationalID'] + ')';
      }

      this.licenseCache['licenseCompanyTenant'] = this.pageTenant.find(k => String(k.carparkID) === String(this.licenseCache['carparkID']) && String(k.customerID) === String(this.licenseCache['customerID'])) ? 'Yes' : 'No';

      this.licenseCache['licenseDeclarationAccount'] = this.licenseCache['licenseNumText'];
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;
      formData.lease.forEach((leaseData, leaseIndex) => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let tandemCalculated = [];
      formData.lease.forEach(leaseData => {
        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }
        
        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        leaseData['_isParkAide'] = parseInt(leaseData['isParkAide']) ? 'Yes' : 'No';

        if(leaseData['passcardID']) {
          leaseData['passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, leaseData['passcardID']));
          leaseData['passcardText'] = (leaseData['passcard'] || {}).sku;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText);
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();
        
        this.$refs['pageTableLease'].setLeaseDataParker(leaseData, this.pageParker.find(k => k['id'] === leaseData['parkerID']));


        if(!this.pageFees[leaseData['seasonID']]) {
          return;
        }
        
        let product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
        if(!product || product.startDate > leaseData['commencementDate']) {
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= leaseData['commencementDate']) {
                product = temp;
                break;
              }
            }
          }
        }
        if(!product) {
          return;
        }
        
        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        let season = this.pageSeason.find(k => k.id === leaseData['seasonID']);
        leaseData['leaseProductName'] = season.name;
        leaseData['leaseZone'] = (this.pageZone.find(k => k.id === season.zoneID) || {}).name;
        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          if(!leaseData['pairID'] || !tandemCalculated.includes(leaseData['pairID'])) {
            leaseTotal[k] += leaseData[k];
          }
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
        tandemCalculated.push(leaseData['pairID']);
      });

      leaseTotal['leaseProductName'] = '';
      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },
    
    printPDF() {
			var doc = new jsPDF('p', 'pt', 'a4', true);
			doc.setFontSize(8.5);
			var rowPerPage = 17;
			
			var table = this.tableToJson($('#jt-table-lease').get(0));
			
			var arr = this.walkDOM(document.getElementById('print_area'));
			
			var marginTopInitial = 30;
			var marginTop = marginTopInitial;
			var marginLeft = 20;
			var marginTopHeader = 12;
			var marginTopIncrement = 18;
			var fullPageHeight = 842 - marginTopInitial - marginTopInitial;
			var fullPageWidth = 595 - marginLeft - marginLeft;
			var leftColumnWidth = 150;
			var columnMargin = 20;
			var rightColumnWidth = fullPageWidth - leftColumnWidth - columnMargin;
			var rowHeight = 45;
			
			doc.setFontType("bold");
			var splitText = $('#title1').html();
			doc.text(splitText, marginLeft, marginTop);
			marginTop += marginTopIncrement;
			var splitText = $('#title2').html();
			doc.text(splitText, marginLeft, marginTop);
			marginTop += 5;
			doc.line(marginLeft, marginTop, fullPageWidth, marginTop);
			marginTop += marginTopIncrement - 5;
			doc.setFontType("normal");
			
			for(var index in arr) {
				if(index === '0') {
					continue;
				}
				
				if(marginTop > fullPageHeight) {
					doc.addPage();
					marginTop = marginTopInitial;
				}
				
				var data = arr[index];
				
				if(data.tagName === 'i') {
          continue;
				}
				
				if(data.id === 'pl-declaration') {
					var text = data.innerHTML.trim();
					text = text.replace(/<\/?[^>]+(>|$)/g, "");
          var splitText = doc.splitTextToSize(text, fullPageWidth);
					doc.text(splitText, marginLeft, marginTop);
					marginTop += marginTopIncrement;
					break;
				}
				
				if(data.id === 'input__bill1') {
					var text = data.innerHTML.trim();
          var splitText = doc.splitTextToSize(text, rightColumnWidth);
					doc.text(splitText, marginLeft + leftColumnWidth + columnMargin, marginTop);
					marginTop += marginTopIncrement;
					marginTop += marginTopIncrement;
					continue;
				}
				
				if(data.id === 'input__bill2') {
					var text = data.innerHTML.trim();
          var splitText = doc.splitTextToSize(text, rightColumnWidth);
					doc.text(splitText, marginLeft + leftColumnWidth + columnMargin, marginTop);
					marginTop += marginTopIncrement;
					marginTop += marginTopIncrement;
					continue;
        }
				
				if(data.tagName === 'H3') {
					if(marginTop !== marginTopInitial) {
						marginTop += marginTopHeader;
					}
					
					doc.setFontType("bold");
					var splitText = data.innerHTML.trim();
					splitText = splitText.replace('&amp;', '&'); 
					doc.text(splitText, marginLeft, marginTop);
					marginTop += marginTopIncrement;
					doc.setFontType("normal");
				}
				
				if(data.tagName === 'LABEL') {
					var text = data.innerHTML.trim();
          var splitText = doc.splitTextToSize(text, leftColumnWidth);
					doc.text(splitText, marginLeft + leftColumnWidth, marginTop, 'right');
				}
				
				if(data.tagName === 'P') {
					var text = data.innerHTML.trim();
          var splitText = doc.splitTextToSize(text, rightColumnWidth);
					doc.text(splitText, marginLeft + leftColumnWidth + columnMargin, marginTop);
					var tempIncrement = splitText.length === 1 ? marginTopIncrement : (splitText.length * 12);
					marginTop += tempIncrement;
				}
        
        var minWidth = 35;
				if(data.tagName === 'TABLE') {
					$.each(table, function(i, row) {
						doc.cellInitialize();
							
						$.each(row, function(j, cell) {
							var width = 50;
							
							if (j === '#') {
								width = 20;
							} else if(j === 'zonename') {
								width = minWidth;
							} else if(j === 'productname') {
								width = 50;
							} else if(j === 'paymentplan') {
								width = minWidth;
							} else if(j === 'commencementdate') {
								width = 50;
							} else if(j === 'deposit(rm)') {
								width = minWidth;
							} else if(j === 'estb.fee(rm)') {
								width = minWidth;
							} else if(j === 'initialparkingfee(rm)') {
								width = minWidth;
							} else if(j === 'initialpayment(rm)') {
								width = minWidth;
							} else if(j === 'parkingfee(rm)') {
								width = minWidth;
							} else if(j === 'parkerinformation') {
								width = 120;
							} else if(j === 'enableparkaide') {
								width = minWidth;
							} else if(j === 'status') {
								width = minWidth;
							}
				
							if (cell) {
								cell = cell.split('<br>')
								for(var index in cell) {
									cell[index] = cell[index].replace(/<(?:.|\n)*?>/gm, '');
								}
								cell = doc.splitTextToSize(cell, width - 5);
							} else {
								cell = " ";
							}
							
							doc.cell(marginLeft, marginTop, width, rowHeight, cell, 0);
						});
						
						marginTop += rowHeight;
						
						if(marginTop > (842 - marginTopInitial - rowHeight)) {
							marginTop = marginTopInitial;
							doc.addPage();
						}
					});
					
					if(marginTop !== marginTopInitial) {
						marginTop += marginTopIncrement;
					}
				}
      }
			
			doc.save(this.licenseNo + '.pdf');
    },
    tableToJson(table) {
			var data = [];
		
			// first row needs to be headers
			var headers = [];
			for (var i = 0; i < table.rows[0].cells.length; i++) {
				headers[i] = table.rows[0].cells[i].innerHTML.toLowerCase().replace(/ /gi, '');
			}
		
			// // for data pagination
			// for (var i = 0; i < fillerRow; i++) {
				// data.push({});
			// }
		
			// go through cells
			for (var i = 0; i < table.rows.length; i++) {
				var tableRow = table.rows[i];
				var rowData = {};
		
				for (var j = 0; j < tableRow.cells.length; j++) {
					var text = tableRow.cells[j].innerHTML;
					text = text.startsWith('-') ? text.replace('-', '') : text;
					rowData[headers[j]] = text;
				}
				
				data.push(rowData);
			}
		
			return data;
    },
    walkDOM(main) {
      var arr = [];
      var loop = function(main) {
        do {
          if(main.nodeType == 1) {
            if(main.id === 'jt-feedback-lease') {
              continue;
            }

            if(main.childNodes.length === 0) {
              continue;
            }

            arr.push(main);
          }
              
          if(main.hasChildNodes()) {
            loop(main.firstChild);
          }
        }
        while (main = main.nextSibling);
      }
      loop(main);
      return arr;
		},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLView.vue